// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const ordersApi = baseApi.injectEndpoints({
  // reducerPath: "ordersApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getAllOrders: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          // url: `orders?search_user=${search_user}&search_restaurant=${search_restaurant}&page=${page}&limit=${limit}`,
          url: `orders?${queryString}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getOrderDetail: builder.query({
      query: ({ slug }) => {
        return {
          url: `orders/${slug}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: (result, error, { slug }) => [{ type: 'OrderDetail', id: slug }],
    }),
    getDelayedOrders: builder.query({
      query: () => {
        return {
          url: "delayed-orders",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["DelayedOrders"],
    }),
    rejectOrder: builder.mutation({
      query: ({ slug, rejection_reason }) => {
        return {
          url: `reject-order/${slug}`,
          method: "POST",
          body: { rejection_reason },
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["DelayedOrders"],
    }),
    changeOrderStatus: builder.mutation({
      query: ({ id, order_status }) => {
        return {
          url: `change-order-status/${id}`,
          method: "PATCH",
          body: { order_status },
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: (result, error, { id }) => [
        "Orders",
        { type: 'OrderDetail', id: id }
      ],
    }),
    getNearbyDrivers: builder.query({
      query: ({ orderSlug }) => {
        return {
          url: `orders/${orderSlug}/nearby-drivers`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
    }),
    assignDriver: builder.mutation({
      query: ({ orderSlug, rider_slug }) => {
        return {
          url: `orders/${orderSlug}/assign-driver`,
          method: "POST",
          body: { rider_slug },
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: (result, error, { orderSlug }) => [
        "Orders",
        { type: 'OrderDetail', id: orderSlug }
      ],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllOrdersQuery,
  useGetOrderDetailQuery,
  useLazyGetOrderDetailQuery,
  useGetDelayedOrdersQuery,
  useRejectOrderMutation,
  useChangeOrderStatusMutation,
  useGetNearbyDriversQuery,
  useAssignDriverMutation,
} = ordersApi;
